import React, { useRef } from "react";
import { Box, Typography, Grid } from "@mui/material";
import { motion, useInView } from "framer-motion"; 
import AgriOne from "../assets/images/Agri-one.png"; 
import AgriTwo from "../assets/images/Agri-two.png";
import AgriThree from "../assets/images/Agri-three.png";
import "../assets/styles/HeroSection.css"; // Keep styles separate

// Variants for text and images
const textVariants = {
  hidden: { x: -50, opacity: 0, filter: "blur(10px)" },
  visible: { 
    x: 0, 
    opacity: 1, 
    filter: "blur(0px)", 
    transition: { duration: 0.8, ease: "easeOut", delay: 0.2 } 
  },
};

const imageVariants = {
  hidden: { opacity: 0, scale: 0.9, filter: "blur(10px)" },
  visible: { 
    opacity: 1, 
    scale: 1, 
    filter: "blur(0px)", 
    transition: { duration: 0.8, ease: "easeOut", delay: 0.4, type: "spring", stiffness: 100 } 
  },
};

const AgricultureSection = () => {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { margin: "-100px" }); 

  return (
    <Box ref={sectionRef} sx={{ backgroundColor: "#121212", color: "white", p: 4,}}>
     <Box sx={{ backgroundColor: "#121212", color: "white", p: 4, borderRadius: 2, mt: 5, mb: 5 }}>
     <Grid container spacing={2} alignItems="stretch">
        
        {/* Left Section - Text + Image */}
        <Grid 
          item xs={12} md={12} 
          sx={{ display: "flex", flexDirection: "column", justifyContent: "center", textAlign: "left" }}
        >
          <motion.div variants={textVariants} initial="hidden" animate={isInView ? "visible" : "hidden"}>
            <Typography variant="h6"  className='Who-heading'  >
              Who We Are
            </Typography>
            <Typography variant="h6" className='Who-subheading' sx={{  mb: 2}}>
            Lirio Blanco is a family-owned business, proudly entering its third generation of delivering excellence in the wholesale trade of premium nuts, spices, and dried hibiscus flowers. We source our products directly from trusted farms and cooperatives across Africa, Asia, Latin America, and the USA, ensuring unmatched quality and sustainability.
            Our operations are Kosher, Halal, FDA, ISO, and HACCP certified, reflecting our commitment to the highest standards of food safety and global compliance. At Lirio Blanco, tradition meets trust — offering nature’s finest, with integrity.            </Typography>
          </motion.div>

   <motion.div variants={textVariants} initial="hidden" animate={isInView ? "visible" : "hidden"}>
              <Typography className='Who-heading'  sx={{ pr: 2, mt:5, textAlign: "left" }}>
                Our Mission
              </Typography>
              <Typography className='Who-subheading'sx={{ mb: 2, pr: 2, textAlign: "left" }}>
              At Lirio Blanco, our mission is to provide high-quality, sustainably sourced agricultural commodities—including nuts, spices, and dried hibiscus flowers—to businesses around the world. We are committed to building ethical, long-term partnerships with farmers, maintaining the highest standards of food safety, and delivering products that bring both flavor and wellness to every table. Through integrity, innovation, and a deep respect for the environment, we aim to create a supply chain that supports healthy living, economic growth, and global sustainability.              </Typography>
            </motion.div>

   <motion.div variants={textVariants} initial="hidden" animate={isInView ? "visible" : "hidden"}>
                  <Typography variant="h6"  className='Who-heading'   sx={{ pr: 2, mt:5, textAlign: "left" }}>
                  Our Vision                  </Typography>
                  <Typography variant="h6" className='Who-subheading' sx={{  mb: 2}}>
                  At Lirio Blanco, our vision is to become a global leader in the sustainable trade of agricultural commodities, connecting farms to markets with transparency, integrity, and care. We envision a future where natural products uplift communities, nourish lives, and protect the planet.  </Typography>
                </motion.div>

                <motion.div variants={textVariants} initial="hidden" animate={isInView ? "visible" : "hidden"}>
                  <Typography variant="h6"  className='Who-heading'   sx={{ pr: 2, mt:5, textAlign: "left" }}>
                  Core Values                 </Typography>
                  <Typography
  variant="h6"
  className="Who-subheading"
  sx={{ mb: 2 }}
>
  <strong>Sustainability</strong> – We prioritize eco-friendly sourcing and responsible farming practices. <br />
  <strong>Integrity</strong> – We conduct business with honesty, fairness, and full transparency. <br />
  <strong>Global Responsibility</strong> – We are committed to ethical trade that empowers communities and preserves our planet.<br />
  <strong>Quality Assurance</strong> – We uphold the highest food safety and product quality standards.<br />
  <strong>Innovation</strong> – We continuously seek better ways to serve our partners and improve our supply chain. <br />
  <strong>Customer Commitment</strong> – We build lasting relationships by consistently exceeding expectations.
</Typography>

                </motion.div>
        
        </Grid>

      

      </Grid>
     </Box>
    </Box>
  );
};

export default AgricultureSection;
